import React from 'react';
import './DeployTimer.css';

type DeployTimerProps = {
    expiration: Date
}

type DeployTimerState = {
    totalSeconds: number,
    secondsRemaining: number
}

class DeployTimer extends React.Component<DeployTimerProps,DeployTimerState> {
    private interval: any;

    constructor(props: DeployTimerProps) {
        super(props);
        this.state = {
            totalSeconds: this.getRemainingSeconds(),
            secondsRemaining: this.getRemainingSeconds()
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({
                secondsRemaining: this.getRemainingSeconds()
            });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const remainingSeconds = this.getRemainingSeconds();
        const remaining = remainingSeconds / this.state.totalSeconds;
        const dashArray = `${(1 - remaining) * 2 * Math.PI * 32} ${remaining * 2 * Math.PI * 32}`;

        return (
            <div className="DeployTimer-Container">
                <p>The deployment token will expire in <pre>{this.getRemainingTime()}</pre></p>
                <svg className="DeployTimer-Circle">
                    <circle cx="32" cy="32" r="32" fill="#8BB63A" stroke="#111" stroke-width="64" stroke-dasharray={dashArray}></circle>
                </svg>
            </div>
        )
    }

    private getRemainingTime(): string {
        const minutes = Math.floor(this.state.secondsRemaining / 60);
        const seconds = this.state.secondsRemaining % 60;
        return `${minutes} minutes and ${seconds < 10 ? " " : ""}${seconds} seconds`;
    }

    private getRemainingSeconds(): number {
        const now = new Date();
        return Math.floor((this.props.expiration.getTime() - now.getTime()) / 1000);
    }
}

export default DeployTimer;